import React, { Component } from 'react';
import { Link } from 'react-router';
import BandcampPlayerSquare from '../../Media/BandcampPlayerSquare';

export default class RecentShows extends Component {

  render() {
    const { } = this.props;

    let album1Id = "2523898494";
    let album1Title = "02.01.20 The Central Saloon - Seattle, WA";

    let album2Id = "2723944638";
    let album2Title = "12.17.19 The Sunset Tavern - Seattle, WA";

    let album3Id = "3653067231";
    let album3Title = "9.30.19 The Sunset Tavern - Seattle, WA";

    return (
      <div className="RecentShows">  	
      	<h2>Featured Shows</h2>

      	<div class="square-container">

          <div class="square RecentShows__square--1">
            <div class="content">
              <BandcampPlayerSquare 
                albumId={album1Id}
                title={album1Title}
              />
            </div>
          </div>

      	  <div class="square RecentShows__square--2">
      	    <div class="content">
      	    	<BandcampPlayerSquare 
      	    		albumId={album2Id}
                title={album2Title}
      	    	/>
      	    </div>
      	  </div>

      	  <div class="square RecentShows__square--3">
      	    <div class="content column">
      	    	<BandcampPlayerSquare 
      	    		albumId={album3Id}
                title={album3Title}
      	    	/>
      	    </div>
      	  </div>

      	</div>

      	<div className="RecentShows__cta">
	      	<Link to="http://www.moosealmighty.bandcamp.com" target="_blank">
	      		Listen to more shows from Moose Almighty
	      	</Link>
      	</div>
      </div>    
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Sections/FeaturedShows/FeaturedShows.js